<div class="duplicate-ils-dialog">
  <div class="dialog-title" mat-dialog-title>
    {{ 'duplicateIlsDialog.dialogTitle' | translate }}
  </div>
  <div class="dialog-content" mat-dialog-content>
    <div [innerHTML]="'duplicateIlsDialog.explanation' | translate"></div>
  </div>
  <div align="end" mat-dialog-actions>
    <button (click)="cancel()" mat-flat-button>{{ 'general.cancel' | translate }}</button>
    <button (click)="duplicate()" color="primary" mat-flat-button>
      {{ 'duplicateIlsDialog.duplicate' | translate }}
    </button>
  </div>
</div>
